// extracted by mini-css-extract-plugin
export default {"h2Wrapper":"H2_h2Wrapper__6E2E1","dot":"H2_dot__-eWSC","h2":"H2_h2__t2KKQ","empty":"H2_empty__qlbrv"};